import React from 'react';
import {
  Search,
  ScanBarcode,
  ShoppingCart,
  Tag,
  Wallet,
  Banknote,
  CreditCard,
  Printer,
  ChevronLeft,
  ChevronRight,
  Check,
  Smartphone,
  Store,
  PackageSearch,
  CircleDollarSign,
  BadgePercent,
  LayoutGrid,
  HandCoins,
  WalletCards,
  Plus,
} from 'lucide-react';

const ICONS = {
  search: Search,
  scan: ScanBarcode,
  cart: ShoppingCart,
  coupon: Tag,
  wallet: Wallet,
  cash: HandCoins,
  banknote: Banknote,
  card: CreditCard,
  loyalty: WalletCards,
  mobile: Smartphone,
  printer: Printer,
  back: ChevronLeft,
  chevronRight: ChevronRight,
  check: Check,
  plus: Plus,
  store: Store,
  packageSearch: PackageSearch,
  dollar: CircleDollarSign,
  grid: LayoutGrid,
} as const;

export type PosIconName = keyof typeof ICONS;

export interface PosIconProps {
  name: PosIconName;
  size?: number;
  strokeWidth?: number;
  className?: string;
  style?: React.CSSProperties;
}

/** Consistent Lucide icons for POS (https://lucide.dev) */
export const PosIcon: React.FC<PosIconProps> = ({
  name,
  size = 18,
  strokeWidth = 2,
  className,
  style,
}) => {
  const Icon = ICONS[name];
  return <Icon size={size} strokeWidth={strokeWidth} className={className} style={style} aria-hidden />;
};

export interface PosIconBadgeProps extends PosIconProps {
  tone?: 'blue' | 'green' | 'violet' | 'slate' | 'orange';
  /** tile = large icon for payment method buttons (reference POS layout) */
  variant?: 'inline' | 'tile';
}

export const PosIconBadge: React.FC<PosIconBadgeProps> = ({
  tone = 'blue',
  size = 22,
  variant = 'inline',
  ...props
}) => (
  <span
    className={`pos-icon-badge pos-icon-badge--${tone}${
      variant === 'tile' ? ' pos-icon-badge--tile' : ''
    }`}
  >
    <PosIcon
      {...props}
      size={size}
      strokeWidth={variant === 'tile' ? 2 : 2.25}
    />
  </span>
);
